import "core-js/modules/es.symbol";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import NavigationMenuItem from './NavigationMenuItem';
import NavigationMenuSignoffItem from './NavigationMenuSignoffItem';
import NavigationMenuHomeItem from './NavigationMenuHomeItem';
import NavigationMenuSearchItem from './NavigationMenuSearchItem';
import NavigationMenuParentItem from './NavigationMenuParentItem';

var getItemComponent = function getItemComponent(item) {
  var linkId = item.linkId;

  if (item.subLevelHierarchyList.size) {
    return NavigationMenuParentItem;
  } else if (linkId === 'SIGN_OFF') {
    return NavigationMenuSignoffItem;
  } else if (linkId === 'ACCOUNT_SUMMARY') {
    return NavigationMenuHomeItem;
  } else if (linkId === 'ENTERPRISE_SEARCH') {
    return NavigationMenuSearchItem;
  } else {
    return NavigationMenuItem;
  }
};

var getItems = function getItems(items) {
  var foundFirstFooterItem = false;
  return items.map(function (item) {
    var className = item.listItemClassName;

    if (!foundFirstFooterItem && typeof className === 'string' && className.includes('navfooter')) {
      item.firstFooterItem = true;
      foundFirstFooterItem = true;
      item.footerItem = true;
    }

    return item;
  });
};

var NavigationMenuItemsList = function NavigationMenuItemsList(_ref) {
  var itemList = _ref.itemList,
      subItems = _ref.subItems,
      containerProps = _objectWithoutProperties(_ref, ["itemList", "subItems"]);

  var items = getItems(itemList.toArray());
  return /*#__PURE__*/React.createElement(Block, containerProps, /*#__PURE__*/React.createElement("ul", null, items.map(function (item, index) {
    var Component = getItemComponent(item);
    return /*#__PURE__*/React.createElement(Component, {
      key: item.linkId,
      item: item,
      isChild: subItems,
      focus: index === 0
    });
  })));
};

export default NavigationMenuItemsList;